import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import {
  bgColor17,
  blackColor,
  blackColor26,
  borderCard04,
  greyShade49,
  greyShade74,
  whiteColor,
} from "configs/styles/muiThemes";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useState } from "react";

function GeneralInformationCard({ title, data }) {
  const [showMore, setShowMore] = useState(false);
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <Stack
      sx={{
        overflow: "hidden",
        borderRadius: "8px",
        border: { xs: "1px solid " + greyShade74, md: borderCard04 },
        height: { md: "100%", xs: "auto" },
        bgcolor: { xs: "transparent", md: whiteColor },
      }}
    >
      <Box
        sx={{
          bgcolor: { md: greyShade49, xs: bgColor17 },
          p: { md: "10px 12px", xs: "6px 8px" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          fontSize={{ md: 13.5, xs: 12.5 }}
          fontWeight={600}
          color={blackColor}
          lineHeight="15px"
        >
          {title}
        </Typography>
        <Box
          sx={{
            // width: "20px",
            height: "20px",
            // bgcolor: "red",
            display: { xs: "flex", md: "none" },
          }}
        >
          {!showMore ? (
            <ExpandMoreRoundedIcon onClick={() => setShowMore(!showMore)} />
          ) : (
            <ExpandLessRoundedIcon onClick={() => setShowMore(!showMore)} />
          )}
        </Box>
      </Box>
      {(matches || showMore) && (
        <Stack
          p={{ md: "12px", xs: "12px 12px 0" }}
          gap={{ md: "6px", xs: "4px" }}
          sx={{
            bgcolor: whiteColor,
            borderRadius: { md: "0", xs: "8px" },
            // border: { md: "none", xs: borderCard04 },
          }}
        >
          {data?.map((item, i) => (
            <Box
              display="flex"
              gap={1}
              key={i}
              pb="6px"
              mb={i + 1 !== data?.length && "8px"}
              borderBottom={i + 1 !== data?.length && "1px solid" + bgColor17}
            >
              <Typography
                fontSize={{ md: 13, xs: 11.5 }}
                fontWeight={500}
                color={blackColor}
                lineHeight="16px"
                sx={{ width: "40%" }}
              >
                {item?.label}
              </Typography>
              <Typography
                fontSize={{ md: 13, xs: 11.5 }}
                fontWeight={400}
                color={blackColor26}
                lineHeight="16px"
                sx={{ width: "60%", textTransform: "capitalize" }}
                textAlign={"end"}
              >
                {item?.value || "-"}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}

export default GeneralInformationCard;
